/**
 * Numero componibile, a partire da come è scritto nella pagina.
 *
 * Lo `(0)` della notazione tedesca è il prefisso **nazionale**: si compone
 * chiamando dall'interno della Germania e si omette chiamando dall'estero.
 * Togliere solo i separatori produrrebbe `+49 0 6762…`, cioè un numero che il
 * telefono accetta e che non squilla da nessuna parte — e l'errore si scopre
 * soltanto quando un cliente prova a chiamare e non ci riesce.
 *
 * Il numero resta scritto per esteso nella pagina, con i separatori: quelli
 * servono a chi legge. (In un modulo proprio: la pagina Impressum esporta solo
 * componenti, come chiede il fast refresh di Vite.)
 */
export function dialable(displayed: string): string {
  return displayed.replace(/\(0\)/g, "").replace(/[^\d+]/g, "");
}
